import last from 'lodash/last';

import {TMonthDays} from '../types';

export const getMonthWeeks = (monthDays: TMonthDays) =>
  monthDays.reduce((result, day, index) => {
    const lastWeek = last(result) ?? [];

    if (index % 7 === 0) {
      result.push([day]);
    } else {
      lastWeek.push(day);
    }

    return result;
  }, [] as TMonthDays[]);
